export interface IManagementHomeLinksParams {
  yachtid: string;
  clientid: string;
  orgid: string;
}
/**
 * Generates management home links based on the provided parameters and user role.
 *
 * @param params - An object containing the yacht ID, client ID, and organization ID.
 * @param params.yachtid - The ID of the yacht.
 * @param params.clientid - The ID of the client.
 * @param params.orgid - The ID of the organization.
 * @param isClientAdmin - A boolean indicating whether the user is a client admin.
 * @returns An array of link objects, each containing a title and an href property.
 */
export const generateManagementHomeLinks = (
  { yachtid, clientid, orgid }: IManagementHomeLinksParams,
  isClientAdmin: boolean,
) => {
  const managementOnly = [
    { title: "Management", href: "/management" },
    { title: "Clients", href: "/management/clients" },
  ];

  const base = [
    { title: "Home", href: "/home" },
    {
      title: "Organizations",
      href: `/management/clients/organizations/${clientid}`,
    },
    {
      title: "Yachts",
      href: `/management/clients/organizations/${clientid}/yachts/${orgid}`,
    },
    {
      title: "Yacht",
      href: `/management/clients/organizations/${clientid}/yachts/${orgid}/yacht/${yachtid}`,
    },
    {
      title: "",
      href: `/management/clients/organizations/${clientid}/yachts/${orgid}/yacht/${yachtid}/`,
    },
  ];

  if (!isClientAdmin) base.splice(1, 0, ...managementOnly);
  return base;
};
